import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = sprawdzanie, false = wylogowany

  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.status === "otp_required" || data.status === "enrollment_required") return data; // wymaga 2FA
    setUser(data);
    return data;
  };

  const completeLogin = (userData) => setUser(userData);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, completeLogin, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
